import '../App.css';
import { SERVER_URL } from '../apis/Api';

function CrossfadeSlider({ images = [] }) {
    return (
        <div style={{ maxWidth: '100%', margin: '4vw auto', padding: '0 10px' }} >
            <div id='crossfadeSlider' class='carousel slide carousel-fade' data-bs-ride='carousel'>
                <div class='carousel-inner'>
                    {images.length > 0 ? (
                        images.map((img, index) => (
                            <div 
                                key={ img.name } 
                                className={ `carousel-item ${ index === 0 ? 'active' : '' }` } 
                                data-bs-interval={ index === 0 ? '1500' : '3000' }
                            >
                                <img 
                                    src={ `${ SERVER_URL }${ img.url }` } 
                                    className='d-block w-100' 
                                    alt=''
                                    onError={ (e) => console.log('Failed to load the image: ', e.target.src) }
                                />                    
                            </div>
                        ))
                    ) : (
                        <div className='carousel-item active'>
                            <div className='d-block w-100' style={{ minHeight: '400px', background: '#f0f0f0' }}></div>
                        </div>
                    )}
                </div>
                <button className='carousel-control-prev' 
                        type='button' 
                        data-bs-target='#crossfadeSlider' 
                        data-bs-slide='prev'>
                    <span class='carousel-control-prev-icon' aria-hidden='true'></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button className='carousel-control-next' 
                        type='button' 
                        data-bs-target='#crossfadeSlider' 
                        data-bs-slide='next'>
                    <span class='carousel-control-next-icon' aria-hidden='true'></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    );
}

export default CrossfadeSlider;